import { render, staticRenderFns } from "./DiskInfo.vue?vue&type=template&id=6590ca73&scoped=true"
import script from "./DiskInfo.vue?vue&type=script&lang=js"
export * from "./DiskInfo.vue?vue&type=script&lang=js"
import style0 from "./DiskInfo.vue?vue&type=style&index=0&id=6590ca73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6590ca73",
  null
  
)

export default component.exports